var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-home"},[_c('div'),_c('div',{staticStyle:{"text-align":"left"}}),_c('div',{staticStyle:{"width":"100%"}}),_c('div',{staticClass:"GoodList"},[_c('AllGoodsList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }